import advantage1Image from '@/assets/sys/official_en/advantage-1.png'
import advantage2Image from '@/assets/sys/official_en/advantage-2.png'
import advantage3Image from '@/assets/sys/official_en/advantage-3.png'
import advantage4Image from '@/assets/sys/official_en/advantage-4.png'
import advantage5Image from '@/assets/sys/official_en/advantage-5.png'
import advantage6Image from '@/assets/sys/official_en/advantage-6.png'
import No1Image from '@/assets/sys/official_en/No1.png'
import No2Image from '@/assets/sys/official_en/No2.png'
import No3Image from '@/assets/sys/official_en/No3.png'
import No4Image from '@/assets/sys/official_en/No4.png'
import No5Image from '@/assets/sys/official_en/No5.png'
import marke1Image from '@/assets/sys/official_en/marke_1.png'
import marke2Image from '@/assets/sys/official_en/marke_2.png'
import marke3Image from '@/assets/sys/official_en/marke_3.png'
import marke4Image from '@/assets/sys/official_en/marke_4.png'
import marke5Image from '@/assets/sys/official_en/marke_5.png'
import productAPPIcon1Image from '@/assets/sys/official_en/pptg.png'
import productAPPIcon2Image from '@/assets/sys/official_en/hwtg.png'
import productAPPIcon3Image from '@/assets/sys/official_en/jtk.png'
import productAPP1Image from '@/assets/sys/official_en/product-app-1.png'
import productAPP2Image from '@/assets/sys/official_en/product-app-2.png'
import productAPP3Image from '@/assets/sys/official_en/product-app-3.png'
import productPCIcon1Image from '@/assets/sys/official_en/rwfbpt.png'
import productPCIcon2Image from '@/assets/sys/official_en/supt.png'
import productPCIcon3Image from '@/assets/sys/official_en/fzpxt.png'
import productPC1Image from '@/assets/sys/official_en/product-pc-1.png'
import productPC2Image from '@/assets/sys/official_en/product-pc-2.png'
import productPC3Image from '@/assets/sys/official_en/product-pc-3.png'
import case1Image from '@/assets/sys/official_en/case_1.png'
import case2Image from '@/assets/sys/official_en/case_2.png'
import case3Image from '@/assets/sys/official_en/case_3.png'

import { validPhone } from '@/utils/reg'

const tabbarList = [
	{
		label: 'HOME',
		href: '#'
	},
	{
		label: 'ADVANTAGE',
		href: '#advantage'
	},
	{
		label: 'PRODUCT',
		href: '#product'
	},
	{
		label: 'OUR ABILITY',
		href: '#marke'
	},
	// {
	// 	label: '优质案例',
	// 	href: '#case'
	// },
	{
		label: 'COOPERATION',
		href: '#cooperation'
	}
]

const swiperList = [
	{
		img: advantage1Image,
		title: 'Traffic',
		subTitle: 'Low-cost public domain traffic acquisition capability'
	},
	{
		img: advantage2Image,
		title: 'Content',
		subTitle: 'Customizable content creation capability'
	},
	{
		img: advantage3Image,
		title: 'Data',
		subTitle: 'Expose and disseminate sales data capabilities across the entire chain'
	},
	{
		img: advantage4Image,
		title: 'Service',
		subTitle: 'Service team based on content production and brand marketing'
	},
	// {
	// 	img: advantage5Image,
	// 	title: 'Service',
	// 	subTitle: 'Service team based on content production and brand marketing'
	// },
	// {
	// 	img: advantage6Image,
	// 	title: '达人',
	// 	subTitle: '优质中长尾达人招募能力'
	// }
]

const productTabbarList = [
	{
		label: 'CleanUp'
	},
	// {
	// 	label: '斗转星图'
	// }
]

const productAPPRenderList = [
	{
		icon: productAPPIcon1Image,
		title: 'Clean up memory',
		subTitle: 'Clear phone memory and release space',
		img: productAPP1Image
	},
	{
		icon: productAPPIcon2Image,
		title: 'clean up garbage',
		subTitle: 'Clear phone garbage and faster operation speed',
		img: productAPP2Image
	},
	{
		icon: productAPPIcon3Image,
		title: 'Clean up similar images',
		subTitle: 'Delete duplicate and redundant images',
		img: productAPP3Image
	}
]

const productPCRenderList = [
	{
		icon: productPCIcon1Image,
		title: '任务发布平台',
		subTitle: '斗转星图一站式服务任务发布更简单',
		img: productPC1Image
	},
	{
		icon: productPCIcon2Image,
		title: '数据平台',
		subTitle: '曝光传播销售全链路数据分析',
		img: productPC2Image
	},
	{
		icon: productPCIcon3Image,
		title: '实时反作弊监控',
		subTitle: '实时监控作弊任务，无所遁形',
		img: productPC3Image
	}
]

const markeRenderList = [
	{
		serialImage: No1Image,
		image: marke1Image,
		title: 'professional team',
		subTitle: 'Expert Team, Efficient Collaboration'
	},
	{
		serialImage: No2Image,
		image: marke2Image,
		title: 'Service Platform',
		subTitle: 'Service Hub, One-Stop Support'
	},
	{
		serialImage: No3Image,
		image: marke3Image,
		title: 'Serve customers',
		subTitle: 'Client-Centric, Dedicated Care'
	},
	{
		serialImage: No4Image,
		image: marke4Image,
		title: 'Technical Capability',
		subTitle: 'Tech-Powered, Precise Compliance'
	},
	{
		serialImage: No5Image,
		image: marke5Image,
		title: 'Operational data',
		subTitle: 'Data Insights, Smart Decisions'
	}
]

const caseSwiperList = [
	{
		img: case1Image,
		title: '翠绿珠宝',
		subTitle: '翠绿制造，追求卓越是翠绿十多年来企业发展的基石；打造民族首饰文化经典品牌是翠绿首饰不懈的追求与前进的方向。',
		playNum: '350.5',
		peopleNum: '1980',
		productionNum: '2346',
		desc: '作品流量平台：抖音、快手等'
	},
	{
		img: case2Image,
		title: '人民小酒',
		subTitle: '岩博酒业企业核心文化——大山文化，岩博的“大山情怀”是朴实、谦逊、深沉、稳重、底蕴丰厚、质感饱满的，岩博的热情好客、开拓进取、继往开来又像大海一样宽广和包容。',
		playNum: '1059',
		peopleNum: '1644',
		productionNum: '4308',
		desc: '作品流量平台：抖音、快手等'
	},
	{
		img: case3Image,
		title: '欧莱雅',
		subTitle: '巴黎欧莱雅中国官方网站，源自法国的知名国际品牌，专业提供全方位女士/男士美肤美发明星产品及方案，立即访问欧莱雅官网，你值得拥有!',
		playNum: '746',
		peopleNum: '1020',
		productionNum: '2196',
		desc: '作品流量平台：抖音、快手等'
	}
]

// const professionOptions = [
// 	{
// 		label: '餐饮',
// 		value: '餐饮'
// 	},
// 	{
// 		label: '美业',
// 		value: '美业'
// 	},
// 	{
// 		label: '服饰',
// 		value: '服饰'
// 	},
// 	{
// 		label: '网服',
// 		value: '网服'
// 	},
// 	{
// 		label: '文化轻工',
// 		value: '文化轻工'
// 	},
// 	{
// 		label: '零售',
// 		value: '零售'
// 	},
// 	{
// 		label: '金融',
// 		value: '金融'
// 	},
// 	{
// 		label: '旅游',
// 		value: '旅游'
// 	},
// 	{
// 		label: '广告传媒',
// 		value: '广告传媒'
// 	},
// 	{
// 		label: '电子科技',
// 		value: '电子科技'
// 	},
// 	{
// 		label: '汽车相关',
// 		value: '汽车相关'
// 	},
// 	{
// 		label: '机械化工',
// 		value: '机械化工'
// 	},
// 	{
// 		label: '生物健康',
// 		value: '生物健康'
// 	},
// 	{
// 		label: '能源/环保',
// 		value: '能源/环保'
// 	},
// 	{
// 		label: '印刷物流',
// 		value: '印刷物流'
// 	},
// 	{
// 		label: '其他',
// 		value: '其他'
// 	}
// ]
const professionOptions = [
	{
		label: 'Catering / F&B',
		value: '餐饮'
	},
	{
		label: 'Beauty & Personal Care',
		value: '美业'
	},
	{
		label: 'Apparel & Fashion',
		value: '服饰'
	},
	{
		label: 'Internet Services',
		value: '网服'
	},
	{
		label: 'Culture & Light Industry',
		value: '文化轻工'
	},
	{
		label: 'Retail',
		value: '零售'
	},
	{
		label: 'Finance',
		value: '金融'
	},
	{
		label: 'Travel & Tourism',
		value: '旅游'
	},
	{
		label: 'Advertising & Media',
		value: '广告传媒'
	},
	{
		label: 'Electronic Technology',
		value: '电子科技'
	},
	{
		label: 'Automotive Related',
		value: '汽车相关'
	},
	{
		label: 'Machinery & Chemical',
		value: '机械化工'
	},
	{
		label: 'Bio-Health / Medical',
		value: '生物健康'
	},
	{
		label: 'Energy / Environment',
		value: '能源/环保'
	},
	{
		label: 'Printing & Logistics',
		value: '印刷物流'
	},
	{
		label: 'Others',
		value: '其他'
	}
]
const formRenderList = [
	{
		label: 'CompanyName',
		value: 'companyName',
		placeholder: 'Please Input'
	},
	{
		label: 'Name',
		value: 'userName',
		placeholder: 'Please Input'
	},
	{
		label: 'Mobile',
		value: 'mobile',
		placeholder: 'Please Input',
		vaildFnc: validPhone
	},
	{
		label: 'Address',
		value: 'address',
		placeholder: 'Please Choose'
	},
	{
		label: 'Profession',
		value: 'profession',
		placeholder: 'Please Choose'
	},
	{
		label: 'ProductIntroduce',
		value: 'productIntroduce',
		placeholder: 'Please Input'
	}
]


export {
	tabbarList,
	swiperList,
	productTabbarList,
	markeRenderList,
	caseSwiperList,
	professionOptions,
	formRenderList,
	productAPPRenderList,
	productPCRenderList
}
